import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {catchError, retry, throwError} from "rxjs";
import {Injectable} from "@angular/core";
import {ApiResponse} from "../shared/model/response/ApiResponse";
import {ApiResponseCodeEnum} from "../shared/enums/api-response-code.enum";
import {AuthenticationService} from "../service/authentication-service";
import {Router} from "@angular/router";
import {AuthenticationResponse} from "../shared/model/response/auth/authentication-response.model";
import {AccessService} from "../service/api/access.service";
import {MessageToastService} from "../service/message-toast.service";

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(
    private authTokenService: AuthenticationService,
    private accessService: AccessService,
    private messageToastService: MessageToastService,
    private router: Router
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let apiResponse = this.transformError(error)
        if (apiResponse?.code) {
          if (apiResponse.code === ApiResponseCodeEnum.FLLOGOUT) {
            this.handleUserFullLogout(apiResponse.message)
          }
          if (apiResponse.code === ApiResponseCodeEnum.PWDRESET) {
            this.handleUserAccountChange();
          }
        }
        return throwError(() => apiResponse)
      })
    );
  }

  handleUserAccountChange() {
    this.accessService.refreshToken().pipe(
      retry(1),
    ).subscribe({
      next: (response: AuthenticationResponse) => this.authTokenService.setSession(response.accessToken),
      error: (apiResponse: ApiResponse<any>) => this.handleUserFullLogout(apiResponse.message)
    })
  }

  //remove the session and navigate to login page.
  handleUserFullLogout(message: string) {
    this.authTokenService.removeSession();
    this.messageToastService.success(message)
    this.router.navigate(["/acesso"]).then()
  }

  //convert the response error into ApiResponseObject.
  transformError(error: HttpErrorResponse) {
    const body = error?.error
    const apiResponse: ApiResponse<any> = body && typeof body === "object"
      ? body
      : {message: "Ocorreu um erro. Por favor, tente novamente.", status: String(error?.status ?? "")}

    if (error.status == 0) {
      const message = "Ocorreu um erro ao conectar-se ao servidor. Por favor, tente novamente mais tarde."
      this.messageToastService.error(message)
      apiResponse.message = apiResponse.message || message
    } else if (body && typeof body === "object" && body.formErrors && typeof body.formErrors === "object") {
      apiResponse.formErrors = new Map(Object.entries(body.formErrors))
    }

    return apiResponse
  }
}
